import apiContentSearch from '../apiContentSearch'
import { UsersEndpoints } from './constants'
import type { UserFindParams, UserFindResponse } from './types'

class UserService {
  static async find(params: UserFindParams): UserFindResponse {
    const url = UsersEndpoints.find()
    const rest = await apiContentSearch.get(url, {
      params
    })

    return rest.data
  }
}

export default UserService
